import React from 'react';
import axios from 'Axios';
import { Grid, Select, Button } from '@material-ui/core';
import styled from 'styled-components';
import Header from './components/Header';
import InternalSlips from './components/InternalSlips';
import InternalSlipsInfoModal from './components/InternalSlipsInfoModal';
import { API_ROOT } from 'Api/Routes';
import { rhythm } from 'Themes/typography';
import SpecificationSheetForm from 'SpecificationSheetForm';
import withSpecSheet from 'SpecificationSheetForm/withSpecSheet';

const SearchBody = styled.div`
  padding: 50px 95px;
  @media screen and (max-width: 1560px) {
    padding: 50px 35px;
  }
`;

const SlipWrapper = styled.div`
  background-color: white !important;
  border: 1px solid black !important;
  margin-bottom: 0px !important;
  > div {
    @media (max-width: 1224px) {
      flex-direction: column;
      text-align: -webkit-center;
    }
    .ticket-image {
      @media (max-width: 1224px) {
        margin-right: 0 !important;
      }
    }
  }
`;

const SpecInfoAndRegionsWrapper = styled.p`
  margin-top: 5px;
  margin-bottom: 5px;
`;

const ButtonWrapper = styled.div`
  margin: 1rem 0;
  display: flex;
  align-content: center;
  justify-content: flex-end;
`;

const Height = styled.div`
  // height: 5000px;
`;

class InternalSearch extends React.Component {
  state = {
    internalData: [],
    openModal: false,
    internalSlip: null,
    internalMessage:
      'Click [INTERNAL] to search for luminaires within the database',
    isInternalOpen: false,
  };
  colapse = () => {
    this.setState({ isInternalOpen: !this.state.isInternalOpen });
  };

  makeInternalSearchRequest = specsheetState => () => {
    let specSheetInternal = JSON.parse(JSON.stringify(specsheetState));
    delete specSheetInternal.manufacturer;
    delete specSheetInternal.efficacy;
    delete specSheetInternal.productRange;
    let formData = new FormData();
    let counter = 0;

    //reset state on default
    this.setState({
      isInternalOpen: false,
      internalData: [],
      internalMessage: '',
    });

    //prepare criteras and values for BE
    Object.entries(specsheetState).forEach(([key, value], index) => {
      if (value.criteriaIdForBe !== 99999 || value.criteriaStringForBe !== '') {
        // special case for IP
        if (value.id === 270) {
          formData.append(`criteria[${counter}].criteriaId`, value.id);
          formData.append(`criteria[${counter}].value`, value.criteriaIdForBe);
          if (value.unit) {
            formData.append(`criteria[${counter}].unit`, null);
          }
          counter++;
        } else if (value.criteriaIdForBe === 99999) {
          // has string to be
          // special case for CRI
          if (value.criteriaStringForBe !== 'Not set') {
            formData.append(`criteria[${counter}].criteriaId`, value.id);
            if (value.criteriaStringForBe !== '') {
              formData.append(
                `criteria[${counter}].value`,
                value.criteriaStringForBe
              );
            }
            if (value.unit) {
              formData.append(`criteria[${counter}].unit`, null);
            }
            counter++;
          }
        } else {
          // send id to be
          formData.append(
            `criteria[${counter}].criteriaId`,
            value.criteriaIdForBe
          );
          if (value.criteriaStringForBe !== '') {
            formData.append(
              `criteria[${counter}].value`,
              value.criteriaStringForBe
            );
          }
          if (value.unit) {
            formData.append(`criteria[${counter}].unit`, value.unit);
          }
          counter++;
        }
      }
    });

    // send only if user select some
    if (formData.has('criteria[0].criteriaId')) {
      axios
        .post('/slip/internal', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.status === 200) {
            this.setState({
              internalData: response.data,
              isInternalOpen: true,
            });
            formData = new FormData();
          }
        })
        .catch(err => {
          if (err.response.data.message) {
            var res = err.response.data.message.slice(15);
            this.setState({
              internalData: [],
              internalMessage: res,
              isInternalOpen: true,
            });
          }
          formData = new FormData();
        });
    } else {
      //user hasent selected criteria
      this.setState({
        internalMessage: 'At least one criteria needed for internal search',
        isInternalOpen: true,
      });
    }
  };

  regionsToString = regions => {
    regions = regions.join(', ');
    return regions.replace(new RegExp('_', 'g'), ' ');
  };

  renderSpecificationSheetInfo = specInfo => {
    if (!specInfo) return;
    delete specInfo.manufacturer;
    return this.regionsToString(Object.values(specInfo));
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  handleOpenModal = index => {
    this.setState({
      openModal: true,
      internalSlip: this.state.internalData[index],
    });
    // this.getCurrentTicket();
  };
  render() {
    return (
      <div className="flex-dashboard">
        <Header history={this.props.history} />
        <SearchBody>
          <h4>
            Select values by which you want to search the internal database
          </h4>
          <SpecificationSheetForm
            specSheet={this.props.specificationSheet}
            handleSelectChange={this.props.handleSelectChange}
            handleInputChange={this.props.handleInputChange}
            paperstyle="true"
            leftSide={[
              'luminaireType',
              'mounting',
              'finish',
              'accessories',
              'protectionRating',
              'protectionRatingIk',
              'opticalDistribution',
              'luminaireLifetime',
              'l',
              'b',
              'lightSourceType',
              'lightSourceColour',
            ]}
            rightSide={[
              'mountingPosition',
              'colourRendering',
              'maxColourVariation',
              'ratedLuminousFlux',
              'inputPower',
              'efficacy',
              'driverLocation',
              'dimmable',
              'dimmingType',
              'emergencyLighting',
              'emergencyType',
            ]}
          />
          <ButtonWrapper>
            <Button
              onClick={this.makeInternalSearchRequest(
                this.props.specificationSheet
              )}
              classes={{
                root: 't-primary-16 c-s-blue',
              }}
              variant="contained"
              color="primary"
            >
              INTERNAL SEARCH
            </Button>
          </ButtonWrapper>
          <InternalSlips
            isOpen={this.state.isInternalOpen}
            colapse={this.colapse}
          >
            {this.state.internalData.length === 0 ? (
              <Grid item xs={12}>
                {this.state.internalMessage}
              </Grid>
            ) : (
              <React.Fragment>
                {this.state.internalData &&
                  this.state.internalData.map((item, index) => {
                    // const date = new Date(item.dateCreated).toLocaleString();
                    return (
                      <Grid
                        key={index}
                        item
                        // style={{ backgroundColor: 'red', padding: '5px' }}
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <SlipWrapper
                          className="favorite-tickets project-card sidebar-tickets"
                          onClick={() => {
                            this.handleOpenModal(index);
                          }}
                        >
                          <div className="ticket-card-basic sidebar-tickets-main">
                            <div className="ticket-image">
                              {this.state.internalData[index] &&
                              this.state.internalData[index].dimensionsImage ? (
                                <div
                                  style={{
                                    backgroundImage: `url(${API_ROOT +
                                      '/asset/' +
                                      this.state.internalData[index]
                                        .dimensionsImage})`,
                                  }}
                                />
                              ) : (
                                <div />
                              )}
                              {this.state.internalData[index] &&
                              this.state.internalData[index]
                                .polarDiagramImage ? (
                                <div
                                  style={{
                                    backgroundImage: `url(${API_ROOT +
                                      '/asset/' +
                                      this.state.internalData[index]
                                        .polarDiagramImage})`,
                                  }}
                                />
                              ) : (
                                <div />
                              )}
                              {this.state.internalData[index] &&
                              this.state.internalData[index].luminaireImage ? (
                                <div
                                  style={{
                                    backgroundImage: `url(${API_ROOT +
                                      '/asset/' +
                                      this.state.internalData[index]
                                        .luminaireImage})`,
                                  }}
                                />
                              ) : (
                                <div />
                              )}
                              <div />
                            </div>
                            <div>
                              <SpecInfoAndRegionsWrapper className="t-secondary-12 c-secondary slip-location ">
                                {this.renderSpecificationSheetInfo(
                                  this.state.internalData[index]
                                    .specificationSheetValue
                                )}
                              </SpecInfoAndRegionsWrapper>
                            </div>
                          </div>
                        </SlipWrapper>
                      </Grid>
                    );
                  })}
              </React.Fragment>
            )}
          </InternalSlips>
          <InternalSlipsInfoModal
            openModal={this.state.openModal}
            handleCloseModal={this.handleCloseModal}
            internalSlip={this.state.internalSlip}
            {...this.props}
          />
        </SearchBody>
      </div>
    );
  }
}

export default withSpecSheet(InternalSearch);
